import { render, staticRenderFns } from "./PreviewModal.vue?vue&type=template&id=4b2f420c&scoped=true&"
import script from "./PreviewModal.vue?vue&type=script&lang=js&"
export * from "./PreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./PreviewModal.vue?vue&type=style&index=0&id=4b2f420c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2f420c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
